import { render } from "./App.vue?vue&type=template&id=f0f73d4c&bindings={\"SwitchComponent\":\"options\",\"UpdateFilters\":\"options\",\"PassAverageData\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script